import { Component } from '@angular/core';
import { CategoryService } from '../../../appshared/masters/category/category.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AppLoaderService } from '../../../common/service/app-loader/app-loader.service';
import { TranslateService } from '@ngx-translate/core';
import { CategoryModule } from '../../../appshared/masters/category/category.module';
import { MatTableDataSource } from '@angular/material/table';
import { environment } from '../../../../environments/environment';
import { ItemModule, ViewItem } from '../../../appshared/invoice/item/item.module';
import { ItemService } from '../../../appshared/invoice/item/item.service';
import { CartService } from '../../../appshared/invoice/cart.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-subcategory',
  templateUrl: './subcategory.component.html',
  styleUrls: ['./subcategory.component.scss']
})
export class SubcategoryComponent {

    public SelectedLanguage: string = "en";
    private sub: any;
    closeModal: any;
    public apiURL: string = "";
    public apiURL2: string = "";
    ComID: number = 2;

    constructor(
        public router: Router, private serv: CategoryService, private servItem: ItemService, private cartService: CartService, private route: ActivatedRoute, private loader: AppLoaderService, public translate: TranslateService,
        private toastr: ToastrService
    ) {
        if (this.translate.currentLang != undefined) {

            this.SelectedLanguage = this.translate.currentLang;
        }


        if (this.SelectedLanguage == 'ar') {
            this.slideConfig = {
                ...this.slideConfig,
                rtl: true,
            };
        }
        else {
            this.slideConfig = {
                ...this.slideConfig,
                rtl: false,
            };
        }
    }

    Cid: number = 0;
    imgTitle: string = 'assets/img/page-title1.jpg';
    CategoryName?: string = "";
    serachName?: string = "";

    ngOnInit(): void {

        this.route.params.subscribe(params => {
            if (+params['catID'] > 0) {
                this.Cid = +params['catID'];
                //this.SCid = +params['scatID'];
                this.FillCategory();
            }
            else {
                this.Cid = 0;
                this.CategoryName = "";
            }

            try {
                this.serachName = params['serachName'];
                if (this.serachName.toString() == 'NaN') {
                    this.serachName = "";
                }

            } catch (e) {
                this.serachName = "";
            }
        });

        


        this.apiURL = environment.apiUrl2 + 'Attachment/Companies/' + this.ComID + '/GnAtt/';
        this.apiURL2 = environment.apiUrl2 + 'Attachment/Companies/' + this.ComID + '/Items/';
    }

    datas: any;

    FillCategory() {
         this.loader.open();
        this.serv.getServiceID(this.Cid, this.ComID)
            .subscribe((res: CategoryModule[]) => {

                this.datas = res;

                if (this.datas.photoPath != '') {
                    this.imgTitle = environment.apiUrl2 + 'Attachment/Companies/' + this.ComID + '/GnAtt/' + this.datas.photoPath;
                }

                if (this.SelectedLanguage != "en") {

                    this.CategoryName = this.datas.nameAr;
                }
                else {

                    this.CategoryName = this.datas.name;
                }
                this.FillSubcategory();
                this.loader.close();
            },
                (err: any) => {
                    this.loader.close();
                    console.log(err);
                });
    }

    slideConfig = {
        slidesToShow: 7,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        infinite: true,
        dots: false,
        arrows: true,
        prevArrow: '<button class="slick-prev custom-arrow"><i class="bx bx-chevron-left"></i></button>',
        nextArrow: '<button class="slick-next custom-arrow"><i class="bx bx-chevron-right"></i></button>',
        rtl: false,
        centerPadding: '5px',
        responsive: [
            {
                breakpoint: 768, // screens below 768px
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 440, // even smaller screens
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            }
        ]
    };



    currentDate = new Date();

    public dataSourceSubcategory = new MatTableDataSource<CategoryModule>();
    public dataSourceItems = new MatTableDataSource<ItemModule>();

    FillSubcategory() {
         //this.loader.open();
        this.serv.getServiceParentID(this.ComID, this.Cid, 'Subcategory' )
            .subscribe((res: CategoryModule[]) => {



                this.dataSourceSubcategory.data = res;

                this.dataSourceItems = new MatTableDataSource<ItemModule>();

                for (let i = 0; i < this.dataSourceSubcategory.data.length && i < 5; i++) {
                    this.fillItems(this.dataSourceSubcategory.data[i].gnCategoryID);
                }

            },
                (err: any) => {
                    this.loader.close();
                    console.log(err);
                });
    }

    onClickSubcategory(scatID: number) {
        this.router.navigate(['shop', { scatID: scatID }]);
    }

    onClickItem(ItemId: number) {
        this.router.navigate(['product-details', { ItemId: ItemId }]);
    }

    addToCart(itemM: ItemModule) {


        this.loader.open();

        var price = itemM.salesPrice;
        if (itemM.activateWebDiscount && itemM.webDiscountFromDate < new Date() && itemM.webDiscountToDate > new Date()) {
            price = itemM.webDiscountAmount;
        }


        var product: ViewItem = {


            inItemID: itemM.inItemID,
            name: itemM.webNameEn,
            nameAr: itemM.webNameAr,
            salesPrice: itemM.salesPrice,
            barcode: itemM.barcode,
            inCategoryID: itemM.inCategoryID,
            description: itemM.description,
            inUnitID: itemM.inUnitID,
            photoPath: itemM.photoPath,
            itemCode: itemM.itemCode,
            unitName: itemM.unitName,
            systemCode: itemM.systemCode,
            categoryNameAr: itemM.categoryNameAr,
            descriptionAr: itemM.descriptionAr,
            categoryName: itemM.categoryName,

            saleTaxPercentage: itemM.saleTaxPercentage,
            isViewWeb: itemM.isViewWeb,
            webDiscountFromDate: itemM.webDiscountFromDate,
            webDiscountToDate: itemM.webDiscountToDate,
            webDiscountAmount: itemM.webDiscountAmount,
            activateWebDiscount: itemM.activateWebDiscount,
            unitNameAr: itemM.unitNameAr,
            webDiscountPercentage: itemM.webDiscountPercentage,
            wholesalePrice: itemM.webDiscountPercentage,

            cartQuantity: 1,
            cartPrice: price

        };



        this.cartService.addToCart(product, 1);

        this.loader.close();

        var transR = this.translate.instant('Your_product_added_to_the_cart');
        this.toastr.success(transR, '');


        //this.servItem.getItemBranchNoSales(this.ComID, itemM.inItemID, 1)
        //    .subscribe(res => {

        //        this.loader.close();
        //        if (+res >= 1) {



        //            var price = itemM.salesPrice;
        //            if (itemM.activateWebDiscount && itemM.webDiscountFromDate < new Date() && itemM.webDiscountToDate > new Date()) {
        //                price = itemM.webDiscountAmount;
        //            }

        //            var product: ViewItem = {


        //                inItemID: itemM.inItemID,
        //                name: itemM.webNameEn,
        //                nameAr: itemM.webNameAr,
        //                salesPrice: itemM.salesPrice,
        //                barcode: itemM.barcode,
        //                inCategoryID: itemM.inCategoryID,
        //                description: itemM.description,
        //                inUnitID: itemM.inUnitID,
        //                photoPath: itemM.photoPath,
        //                itemCode: itemM.itemCode,
        //                unitName: itemM.unitName,
        //                systemCode: itemM.systemCode,
        //                categoryNameAr: itemM.categoryNameAr,
        //                descriptionAr: itemM.descriptionAr,
        //                categoryName: itemM.categoryName,

        //                saleTaxPercentage: itemM.saleTaxPercentage,
        //                isViewWeb: itemM.isViewWeb,
        //                webDiscountFromDate: itemM.webDiscountFromDate,
        //                webDiscountToDate: itemM.webDiscountToDate,
        //                webDiscountAmount: itemM.webDiscountAmount,
        //                activateWebDiscount: itemM.activateWebDiscount,
        //                unitNameAr: itemM.unitNameAr,
        //                webDiscountPercentage: itemM.webDiscountPercentage,
        //                wholesalePrice: itemM.webDiscountPercentage,

        //                cartQuantity: 1,
        //                cartPrice: price


        //            };

        //            this.cartService.addToCart(product, 1);

        //            var transR = this.translate.instant('Your_product_added_to_the_cart');
        //            this.toastr.success(transR, '');


        //        }
        //        else {

        //            var transR = this.translate.instant('This_Item_Out_of_Stock');
        //            this.toastr.warning(transR, '');
        //        }

        //    },
        //        (err: any) => {
        //            console.log(err);
        //        });
    }

    fillItems(SCid: number) {
        //this.dataSourceItems = new MatTableDataSource<ItemModule>();
        //this.loader.open();
        this.servItem.getService(this.ComID, this.Cid, SCid, this.serachName, "Default")
            .subscribe((res: ItemModule[]) => {
                this.loader.close();

                for (var i = 0; i < res.length; i++) {
                    res[i].webDiscountFromDate = new Date(res[i].webDiscountFromDate);
                    res[i].webDiscountToDate = new Date(res[i].webDiscountToDate);

                    res[i].newArrivalFromDate = new Date(res[i].newArrivalFromDate);
                    res[i].newArrivalToDate = new Date(res[i].newArrivalToDate);
                }

                this.dataSourceItems.data = [
                    ...this.dataSourceItems.data,
                    ...(res as ItemModule[])
                ];


            },
                (err: any) => {
                    this.loader.close();
                    console.log(err);
                });
    }

    currPages: number = 1;

    onPageClick(event) {
        window.scroll(0, 0);

        this.currPages = event;
    }
}
